var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "44px",
    viewBox: "0 0 65 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "master-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1-Wallet/Payment_19",
    transform: "translate(-1421.000000, -256.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1213.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "master-card",
    transform: "translate(208.400000, 17.066667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,38.9643089 C64,40.9790433 62.30625,42.6123089 60.216875,42.6123089 L3.783125,42.6123089 C1.69375,42.6123089 0,40.9788023 0,38.9643089 L0,3.70223729 C0,1.68750282 1.69375,0.0543578154 3.783125,0.0543578154 L60.21675,0.0543578154 C62.30625,0.0543578154 64,1.68762335 64,3.70223729 L64,38.9643089 L64,38.9643089 Z",
    id: "Path",
    fill: "#E7E8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#34495E",
    x: 0,
    y: 8.33205273,
    width: 64,
    height: 8.67917137
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 17.0136347,
    width: 64,
    height: 5.37009416
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.689625,38.9643089 L2.689625,3.70223729 C2.689625,1.68750282 4.383625,0.0543578154 6.473,0.0543578154 L3.783,0.0543578154 C1.69375,0.0543578154 0,1.68774388 0,3.70223729 L0,38.9643089 C0,40.9790433 1.69375,42.6123089 3.783125,42.6123089 L6.473125,42.6123089 C4.38375,42.6123089 2.689625,40.9788023 2.689625,38.9643089 Z",
    id: "Path",
    fill: "#202121",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.869625,32.4448663 C46.869625,30.6347872 47.734625,29.0197213 49.087375,27.9620942 C48.059,27.1582976 46.74925,26.6761883 45.322375,26.6761883 C42.01825,26.6761883 39.33975,29.2588475 39.33975,32.4448663 C39.33975,35.6308851 42.01825,38.2135443 45.322375,38.2135443 C46.74925,38.2135443 48.059125,37.7315556 49.087375,36.9276384 C47.7345,35.8700113 46.869625,34.2549454 46.869625,32.4448663 Z",
    id: "Path",
    fill: "#EA001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.852125,26.6761883 C51.42525,26.6761883 50.115375,27.158177 49.08725,27.9620942 C50.44025,29.0197213 51.304875,30.6347872 51.304875,32.4448663 C51.304875,34.2549454 50.440125,35.8700113 49.08725,36.9276384 C50.115625,37.731435 51.425375,38.2135443 52.852125,38.2135443 C56.1565,38.2135443 58.835,35.6308851 58.835,32.4448663 C58.835,29.2588475 56.1565,26.6761883 52.852125,26.6761883 Z",
    id: "Path",
    fill: "#F79F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.304875,32.4448663 C51.304875,30.6347872 50.440125,29.0197213 49.08725,27.9620942 C47.7345,29.0197213 46.8695,30.6347872 46.8695,32.4448663 C46.8695,34.2549454 47.7345,35.8700113 49.08725,36.9276384 C50.44025,35.8700113 51.304875,34.2549454 51.304875,32.4448663 Z",
    id: "Path",
    fill: "#FF5F01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.875000, 27.359699)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.132875,2.01557815 L1.054625,2.01557815 C0.47825,2.01557815 0.011125,1.56528814 0.011125,1.0094162 C0.011125,0.453664783 0.478125,0.00325423729 1.054625,0.00325423729 L14.132875,0.00325423729 C14.70925,0.00325423729 15.176375,0.453544256 15.176375,1.0094162 C15.176375,1.56528814 14.70925,2.01557815 14.132875,2.01557815 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.132875,6.19775518 L1.054625,6.19775518 C0.47825,6.19775518 0.011125,5.74746516 0.011125,5.19159322 C0.011125,4.63572128 0.478125,4.18543126 1.054625,4.18543126 L14.132875,4.18543126 C14.70925,4.18543126 15.176375,4.63572128 15.176375,5.19159322 C15.176375,5.74746516 14.70925,6.19775518 14.132875,6.19775518 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.132875,10.3799322 L1.054625,10.3799322 C0.47825,10.3799322 0.011125,9.92964218 0.011125,9.37377024 C0.011125,8.81801883 0.478125,8.36760829 1.054625,8.36760829 L14.132875,8.36760829 C14.70925,8.36760829 15.176375,8.81789831 15.176375,9.37377024 C15.176375,9.92940113 14.70925,10.3799322 14.132875,10.3799322 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMt);
export default __webpack_public_path__ + "static/media/Card-MT.dda37ffdf613238ed83e9b6fb1c4765c.svg";
export { ForwardRef as ReactComponent };